import { Component, inject, OnInit } from '@angular/core';
import { NbFormFieldModule, NbInputModule, NbListModule, NbTreeGridModule } from '@nebular/theme';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IInvestmentWizard } from '../wizard-interface';
import { KPI } from '../../../../../@core/api';
import { InvestmentWizardService } from '../../../../../@core/utils/investment-wizard-service';

type T = KPI.Perimeter & { children?: KPI.Perimeter[] };

@Component({
  selector: 'app-wizard-mono-perimeter-selection',
  standalone: true,
  imports: [
    NbListModule,
    CommonModule,
    NbInputModule,
    NbFormFieldModule,
    TranslateModule,
    NbTreeGridModule,
  ],
  template: `
    <div class="d-flex flex-row wrapper">
      <ul class="list-group w-100 border-0 py-1">
        @for (monoP of monoPs; track monoP.id) {
          <li (click)="setMonoP(monoP)" class="pointer list-group-item border-0 py-3 border-bottom"
              [class.selected]="state()?.id === monoP.id">
            {{ monoP.name }}
          </li>
          <ul class="list-group ps-4 w-100 border-0 py-1">
            @if (monoP.children) {
              @for (monoPLvl2 of monoP.children; track monoPLvl2.id) {
                <li (click)="setMonoP(monoPLvl2)" class="pointer pb-3 list-group-item border-0 border-bottom"
                              [class.selected]="state()?.id === monoPLvl2.id">
                  {{ monoPLvl2.name }}
                </li>
              }
            }
          </ul>
        }
      </ul>
    </div>
  `,
  styleUrl: '../wizard-index.component.scss',
})
export class MonoPerimeterSelectionComponent implements OnInit, IInvestmentWizard {
  readonly stateKey = 'MONO_PERIMETER_SELECTION';
  state = () => this.wizardService.getState(this.stateKey);

  // internal state
  site: KPI.Perimeter;
  monoPs: T[];

  private wizardService = inject(InvestmentWizardService);

  ngOnInit() {
    if (!this.state()?.id) {
      this.wizardService.blockCurrentStep('Please select an option');
    } else {
      this.wizardService.unblockCurrentStep();
    }
    this.site = this.wizardService.getState('SITE_SELECTION');
    this.monoPs = this.convertToTree(this.site.sub_perimeters);
  }

  convertToTree(perimeters: KPI.Perimeter[]): T[] {
    const map = new Map();
    const roots = [];

    // Initialize map
    for (const item of perimeters) {
      map.set(item.id, { ...item, children: [] });
    }

    // Build hierarchy
    for (const item of map.values()) {
      if (item.level_parent) {
        const parent = map.get(item.level_parent);
        if (parent) parent.children.push(item);
      } else {
        roots.push(item);
      }
    }

    return roots;
  }

  setMonoP(monoP: KPI.Perimeter) {
    this.wizardService.setState(this.stateKey, monoP);
    this.wizardService.next()
  }
}
